export default __webpack_public_path__ + "static/media/banner.b3b41faa.png";